import * as React from 'react';
import PropTypes from 'prop-types';

import { cn } from '../../libraries/tailwind/utils';

const Table = React.forwardRef(({ className, ...props }, ref) => (
  <div className='relative w-full overflow-visible table-height shadow-md rounded-md'>
    <table
      ref={ref}
      className={cn('w-full caption-bottom text-sm', className)}
      {...props} />
  </div>
));
Table.displayName = 'Table';

const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
  <thead
    ref={ref}
    id='table-header'
    className={cn(
      '[&_tr]:border-b-2 sticky top-0 z-9 bg-white',
      className
    )}
    {...props}
  />
));
TableHeader.displayName = 'TableHeader';

const TableBody = React.forwardRef(({ className, ...props }, ref) => (
  <tbody
    ref={ref}
    className={cn('[&_tr:last-child]:border-0', className)}
    {...props} />
));
TableBody.displayName = 'TableBody';

const TableFooter = React.forwardRef(({ className, ...props }, ref) => (
  <tfoot
    ref={ref}
    className={cn('border-t bg-muted/50 font-medium [&>tr]:last:border-b-0', className)}
    {...props} />
));
TableFooter.displayName = 'TableFooter';

const TableRow = React.forwardRef(({ className, ...props }, ref) => (
  <tr
    ref={ref}
    className={cn(
      'border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted',
      className
    )}
    {...props} />
));
TableRow.displayName = 'TableRow';

const TableHead = React.forwardRef(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={cn(
      'h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:px-1',
      className
    )}
    {...props} />
));
TableHead.displayName = 'TableHead';

const TableCell = React.forwardRef(({ className, ...props }, ref) => (
  <td
    ref={ref}
    className={cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className)}
    {...props} />
));
TableCell.displayName = 'TableCell';

const TableCaption = React.forwardRef(({ className, ...props }, ref) => (
  <caption
    ref={ref}
    className={cn('mt-4 text-sm text-muted-foreground', className)}
    {...props} />
));
TableCaption.displayName = 'TableCaption';

Table.propTypes = {
  className: PropTypes.string
};

TableHeader.propTypes = {
  className: PropTypes.string
};

TableBody.propTypes = {
  className: PropTypes.string
};

TableFooter.propTypes = {
  className: PropTypes.string
};

TableRow.propTypes = {
  className: PropTypes.string
};

TableHead.propTypes = {
  className: PropTypes.string
};

TableCell.propTypes = {
  className: PropTypes.string
};

TableCaption.propTypes = {
  className: PropTypes.string
};

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption
};
